import { gql } from '@apollo/client'

export const GET_ANGX_STOCK_SNAPSHOT = gql`
  query getAngxStockSnapshot {
    angxStockSnapshot {
      id
      price
      changePercent
      timestamp
    }
  }
`
